import { useSnackbar } from "notistack";
import React, { useCallback } from "react";
import ForgotPasswordForm from "../../components/ScreenForgotPassword/ForgotPasswordForm";
import Layout from "../../components/UI/Layouts";
import Content from "../../components/UI/Layouts/Content";
import { useStores } from "../../hooks/useStores";
import { useTranslation } from "react-i18next";

const ForgotPassword: React.FC = () => {
  const { t } = useTranslation();
  const { session } = useStores();
  const { enqueueSnackbar } = useSnackbar();

  const handleSubmitForm = useCallback(
    async (email: string) => {
      await session
        .sendRecoveryLink(email)
        .then(() => {
          enqueueSnackbar(t("common.actionExecutedSuccessfully"), {
            variant: "success",
          });
        })
        .catch((err) => {
          enqueueSnackbar(err.message, {
            variant: "error",
          });
        });
    },
    [session]
  );

  return (
    <Layout hideSidebar={true} hideFooter>
      <Content fullHeight align="center">
        <ForgotPasswordForm handleSubmitForm={handleSubmitForm} />
      </Content>
    </Layout>
  );
};

export default ForgotPassword;
